// Schema-driven report card types

export enum ReportCardLevel {
  BRONZE = 'BRONZE',
  SILVER = 'SILVER',
  GOLD = 'GOLD'
}

export interface ReportCardComponentProps {
  data: any;
  baseData: any;
  playerAssessment: IPlayerAssessment;
  player: IPlayer;
  reportCardLevel?: ReportCardLevel;
  organizationLogo?: string | React.ReactNode;
  organizationLogoHeight?: string | number; // Height for organization logo (e.g., '80px', 80)
  hidePlainTextScores?: boolean; // Whether to hide plain text scores in charts and tooltips
  maxWidthRestrictions?: {
    desktop?: string | number;
    tablet?: string | number;
    mobile?: string | number;
    default?: string | number;
  };
  context?: { [key: string]: any }; // Includes responsive info and other contextual data
  [key: string]: any;
}

export interface ComponentSchema {
  type: string;
  props?: { [key: string]: any };
  children?: ComponentSchema[];
  dataKey?: string;           // Key to lookup in the data object
  required?: boolean;         // If true and data is missing, use fallback or skip
  fallbackComponent?: ComponentSchema; // Alternative component to render if data is missing
  staticData?: any;           // Static data to pass to component (overrides dataKey)
  supportedReportCardLevels?: ReportCardLevel[]; // If specified, component only shows for these levels
  supportedPositions?: string[]; // If specified, component only shows for these positions
  hiddenForPositions?: string[]; // If specified, component is hidden for these positions
  hiddenForReportCardLevels?: ReportCardLevel[]; // If specified, component is hidden for these levels
  maxWidthRestrictions?: {    // Max-width restrictions for responsive use cases
    desktop?: string | number;  // e.g., '600px', 600, 'none'
    tablet?: string | number;   // e.g., '400px', 400, 'none'
    mobile?: string | number;   // e.g., '300px', 300, 'none'
    default?: string | number;  // Fallback if device-specific not provided
  };
}

export interface ReportCardSchema {
  id: string;
  name: string;
  version: string;
  layout?: ComponentSchema;
  components: ComponentSchema[];
  styling?: {
    theme?: string;
    customStyles?: { [key: string]: any };
  };
  dataSources?: {
    [key: string]: {
      path: string;
      defaultValue?: any;
    };
  };
}

export interface SchemaComponentRegistry {
  [componentType: string]: React.ComponentType<ReportCardComponentProps>;
}
